import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import i18n from '../i18n';

interface LanguageInitializerProps {
  children: React.ReactNode;
}

const LanguageInitializer: React.FC<LanguageInitializerProps> = ({ children }) => {
  const { userData } = useAuth();
  const hasInitialized = useRef(false);

  useEffect(() => {
    // Skip if already initialized or no userData
    if (hasInitialized.current || !userData) {
      return;
    }

    const initializeLanguage = async () => {
      if (userData.preferred_language) {
        const userManuallyChangedLang = localStorage.getItem('userManuallyChangedLang');
        const currentLang = i18n.language;
        
        // Apply user's preferred language if they haven't manually changed it
        // and if it's different from current language
        if (!userManuallyChangedLang && currentLang !== userData.preferred_language) {
          try {
            await i18n.changeLanguage(userData.preferred_language);
          } catch (error) {
            console.error('Error changing language:', error);
          }
        }
      }
      hasInitialized.current = true;
    };

    initializeLanguage();
  }, [userData]);

  // Always render children - don't block the UI
  return <>{children}</>;
};

export default LanguageInitializer;